import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';

// Public blog pages
import HomePage from './pages/blog/HomePage';
import PostDetailPage from './pages/blog/PostDetailPage';
import ArchivePage from './pages/blog/ArchivePage';
import CategoriesPage from './pages/blog/CategoriesPage';
import AuthorsPage from './pages/blog/AuthorsPage';
import AuthorDetailPage from './pages/blog/AuthorDetailPage';
import TagPage from './pages/blog/TagPage';

// Static pages
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

// Auth pages
import LoginPage from './pages/LoginPage';

// Protected admin pages
import DashboardPage from './pages/DashboardPage';
import NewPostPage from './pages/admin/NewPostPage';
import ModerateCommentsPage from './pages/admin/ModerateCommentsPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public blog routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/posts/:slug" element={<PostDetailPage />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/authors" element={<AuthorsPage />} />
          <Route path="/authors/:slug" element={<AuthorDetailPage />} />
          <Route path="/tag/:slug" element={<TagPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />

          {/* Auth routes */}
          <Route path="/auth/login" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Protected admin routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/posts/new"
            element={
              <ProtectedRoute>
                <NewPostPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/comments/moderate"
            element={
              <ProtectedRoute>
                <ModerateCommentsPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
